import { Route, Routes } from 'react-router-dom';
import AlertsList from './alerts-list';

const AlertsRouting = () => {
  return (
    <Routes>
      <Route path='' element={<AlertsList />} />
    </Routes>
  );
};

export default AlertsRouting;
